export default {
    status: {
        acknowledged: "Besteld",
        created: "Gemaakt",
        sent: "Besteld",
        confirmed: "Besteld",
        not_confirmed: "Niet besteld",
        delivery_email: "Verzonden",
        delivery_rejected: "Uitzondering voor levering",
        delivery_rejected_not_confirmed: "Uitzondering voor levering",
        shipped: "Verzonden",
        delayed: "Vertraagd",
        preparing: "Voorbereiding",
        processing: "Verwerking",
        processed: "Verwerkt",
        submitted: "Besteld",
        delivery_not_received: "Verzonden",
        shipment_exception: "Verzonden",
        pre_pending_approval: "In behandeling",
        pending_approval: "In behandeling",
        approved: "Goedgekeurd",
        not_approved: "Niet goedgekeurd",
        canceled: "Geannuleerd",
        returned: "Teruggekeerd",
        lost_shipment: "Verloren zending",
        delivery_not_confirmed: "Afgeleverd",
        delivered: "Afgeleverd",
        delivery_received: "Afgeleverd",
        refurbished: "Teruggave voltooid",
        returned_to_office: "Teruggekeerd naar kantoor",
        return_to_employer: "Teruggegeven aan werkgever",
        return_pickup_scheduled: "Ophalen gepland",
        return_pickup_completed: "Ophalen voltooid",
        return_pickup_excluded: "Afhalen uitgesloten",
        return_pickup_submitted: "Ophalen ingediend",
        return_pickup_finalized: "Afhalen afgerond",
        disposed: "Afgevoerd",
        damaged: "Beschadigd",
        transferred: "Overgedragen",
        transfer_received: "Overdracht ontvangen"
    }
}